import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'

import type { Bid } from '@app/models/bid'
import { ProfilePhotoComponent } from '@app/modules/profile/components/profile-photo/profile-photo.component'

import { TopAdmirerBadgeComponent } from '../top-admirer-badge/top-admirer-badge.component'

@Component({
  selector: 'sb-bid-list',
  templateUrl: './bid-list.component.html',
  styleUrls: ['./bid-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, ProfilePhotoComponent, TopAdmirerBadgeComponent],
})
export class BidListComponent {
  @Input({ required: true }) bids!: Bid[]
  @Input({ required: true }) distinguishedBidsCount!: number
}
